import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, HostListener, inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { AuthService } from '@spartacus/core';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { isPlatformBrowser, Location } from '@angular/common';
import { Subject, Subscription } from 'rxjs';
@Component({
  selector: 'app-kb-scrollableheader',
  templateUrl: './kb-scrollableheader.component.html',
  styleUrls: ['./kb-scrollableheader.component.scss'],
  standalone: false
})
export class KbScrollableheaderComponent {
  showComponent: boolean = false;
  showSearch: boolean = false;
  isLoggedIn: boolean = false;
  isMobile: boolean = false;
  subscription: any;
  platformId = inject(PLATFORM_ID);
  private readonly destroy$ = new Subject<void>();
  private observer!: MutationObserver;
  constructor(
    private authService: AuthService,
    private location: Location,
    public breakpointObserver: BreakpointObserver,
    private renderer: Renderer2
  ) {
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(takeUntil(this.destroy$)).subscribe((result) => {
      this.isMobile = result.matches;
    });
    this.authService
      .isUserLoggedIn()
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe((data) => {
        this.isLoggedIn = data;
      });
  }
  @HostListener('window:scroll')
  checkScroll() {
    if (isPlatformBrowser(this.platformId)) {
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

      const triggerScrollPosition = 200;

      this.showComponent = scrollPosition >= triggerScrollPosition;
    }
  }

  ngOnInit() {
    this.subscription = this.location.onUrlChange((url: string) => {
      if (url) {
        this.showSearch = false;
      }
    });
  }
  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.initMutationObserver();
    }
  }
  private initMutationObserver(): void {
    this.observer = new MutationObserver(() => {
      const buttons = document.querySelectorAll(
        'cx-navigation-ui.flyout > nav > ul > li > button[title]'
      );

      if (buttons?.length) {
        buttons.forEach((btn: HTMLElement) => {
          this.renderer.removeAttribute(btn, 'title');
        });
        this.observer.disconnect();
      }
    });

    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
  ngOnDestroy() {
    if (this.subscription && this.subscription instanceof Subscription) {
      this.subscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
